import React from "react";
import { Link } from "react-router-dom";
import * as actions from '../Actions';
import User from './QuickUsers';
import Service from '../../service/Service';
const service = new Service();
import ShareOptions from './ShareOptions';

export default function QuickCommentList({ quickread, comments, eleRef }) {
    return (
        <div className="comment_container">
            {comments && comments.map((comment, cindex) =>
                <div key={cindex} className="quickread-comment" id={`comment_${comment.commentId}`}>
                    <Link to={service.getRedirectUrl(`/user-profile/${comment.userId}`)}>
                        <User user={comment} isAnonymus={comment.isAnonymus} eleRef={eleRef} />
                    </Link>
                    {comment.parentComment && comment.parentComment.parentText && comment.parentComment.parentText != '' &&
                        <div className="quickread-replyof">
                            <div className="quickread-replyof-title">
                                <span className="R13_75">In reply to </span>
                                {comment.parentComment.parentUserName && comment.parentComment.parentUserName != '' ?
                                    <span className="M14_42">{comment.parentComment.parentUserName}</span>
                                    :
                                    <span className="M14_42">Community User</span>
                                }
                            </div>
                            <div className="quickread-replyof-content">
                                <span className="R11_61">{comment.parentComment.parentText}</span>
                            </div>
                        </div>
                    }
                    <div className="comment-detail">
                        <div className="quickread-summary">
                            <div className="comment-content">
                                {/* <span className="R14_61" dangerouslySetInnerHTML={{ __html: actions.filterLink(comment.comment) }}></span> */}
                                <span className="R14_61" id={`moretext_${comment.commentId}`}>{actions.filterLink(comment.comment)}</span>
                            </div>
                            {comment.urls && comment.urls.length > 0 && comment.urls.map((url, key) =>
                                <span key={key} className="quickread-attachment">
                                    {url.type == "pdf" &&
                                        <span className="quickread-pdf">
                                            <a href={url.source} download>
                                                <div data-icon-font="&#xe039;" className="icon"></div>
                                            </a>
                                        </span>
                                    }
                                </span>
                            )}
                        </div>
                        <div className="readmore_popup" data-id={`moretext_${comment.commentId}`}>
                            <div className="readmorequicklink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${comment.commentId}`)}>Read More</div>
                        </div>
                    </div>
                    {comment.urls && comment.urls.length > 0 && comment.urls.map((url, key) =>
                        <div key={key}>
                            {url.type != "pdf" && url.source && url.source != '' &&
                                <div className="quickread-single-attachment">
                                    <span className="quickread-single-image">
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg" />
                                    </span>
                                </div>
                            }
                        </div>
                    )}
                    <div className="quickread-likes" data-count={comment.likeCount}>
                        {comment.likeCount && comment.likeCount > 0 ?
                            <span className="R11_9e" onClick={() => actions.getCmtLikeUsers(comment.commentId, comment.userId, comment.parentComment ? 1 : 0, comment.likeCount)}> {service.intToString(comment.likeCount)}
                                {comment.likeCount > 1 ?
                                    ' Likes'
                                    :
                                    ' Like'
                                }
                            </span>
                            : <span className="R11_9e dnone"></span>
                        }
                        {comment.replyCount && comment.replyCount > 0 ?
                            <Link to={service.getRedirectUrl(`/quick-reads/${quickread.quickreadtype}/${service.replaceSymbols(quickread[0].title)}/${quickread[0].discussionId}?cid=${comment.commentId}&pt=1`)}>
                                <span className="R11_9e"> {service.intToString(comment.replyCount)}
                                    {comment.replyCount > 1 ?
                                        ' Comments'
                                        :
                                        ' Comment'
                                    }
                                </span>
                            </Link>
                            : ''
                        }
                    </div>
                    <div className="divider_line"></div>
                    <div className="quickread-links">
                        <span className={comment.isMyLike == 1 ? "quickread_social_actions cursor-pointer M13_422 likeCmtIcon is-active" : "quickread_social_actions cursor-pointer M13_422 likeCmtIcon"} onClick={() => actions.likeQuickComment(quickread[0].discussionId, quickread[0].userId, quickread[0].groupId, quickread[0].categoryId, quickread[0].title, quickread[0].urls && quickread[0].urls[0] ? quickread[0].urls[0].source : '', comment.parentComment ? JSON.stringify(comment.parentComment) : '', comment.commentId, comment.userId, comment.comment, comment.isMyLike == 1 ? 0 : 1, eleRef)}>
                            {comment.isMyLike == 1 ?
                                <span data-icon-font="&#xe021;" className="icon like-cmnt"></span>
                                :
                                <span data-icon-font="&#xe009;" className="icon like-cmnt"></span>
                            }
                            
                            <span className="social_action_names dev_like">Like</span>
                        </span>
                        <span className="quickread_social_actions cursor-pointer M13_422 openComment" onClick={() => actions.openCommentPopup(comment.commentId, comment.comment, comment.userId, comment.userName, comment.isAnonymus, comment.parentComment ? JSON.stringify(comment.parentComment) : '', quickread[0].discussionId, quickread[0].groupId, quickread[0].categoryId, quickread[0].title, quickread[0].urls && quickread[0].urls[0] ? quickread[0].urls[0].source : '')}>
                            <span data-icon-font="&#xe01d;" className="icon dev_reply"></span>
                            <span className="social_action_names dev_reply">Comments</span>
                        </span>
                        <div className="M13_422 card-share" id={`share_${comment.commentId}`}>
                            <div className="share-container" onClick={() => actions.shareOn(comment.commentId)}>
                                <span data-icon-font="&#xe027;" className="icon L14_9e share-icon"></span>
                                <div className="social_action_names share-text">Share</div>
                            </div>
                            <ShareOptions quickread={quickread[0]} eleRef={this} />
                        </div>
                        {comment.userId != global.userAry['mycid'] &&
                            <span className={comment.isAbuse == 1 ? "social-icons-links M13_422 report_abuse is-active" : "social-icons-links M13_422 report_abuse"} title={comment.isAbuse == 1 ? "Already Reported as Abuse" : "Report Abuse"}>
                                <span data-icon-font="&#xe002;" className="icon icon3dot" onClick={() => actions.showAbuse(comment.commentId)}></span>
                                {comment.isAbuse == 1 ?
                                    <div className="abuse-tooltip">Already Reported as Abuse</div>
                                    :
                                    <div className="abuse-tooltip" onClick={() => actions.reportAbuse(comment.commentId, quickread[0].groupId, quickread[0].categoryId)}>Report Abuse</div>
                                }

                            </span>
                        }
                    </div>
                </div>
            )}
        </div>
    );
}
